base = GENERATED_BASE_MESSAGES
window.devBaseMessages = base if IS_DEVELOPMENT or IS_STAGE
export default base
